import { render, staticRenderFns } from "./FormatListCheckbox.vue?vue&type=template&id=5c425ae5&"
import script from "./FormatListCheckbox.vue?vue&type=script&lang=js&"
export * from "./FormatListCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports